<div *ngIf="hasRoleDashboardView" class="container-fluid py-4">
  <!-- Header -->
  <div class="mb-4 header-section">
    <div class="d-flex align-items-center mb-2">
      <i class="fa-solid fa-chart-line me-3 text-primary" style="font-size: 2.5rem;"></i>
      <div>
        <h2 class="mb-1">
          <span translate>$index.txtWelcome</span> {{ userFullName }}!
        </h2>
        <p class="text-muted mb-0" translate>$index.txtSubtitle</p>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <app-generic-filter
    [filterForm]="filterForm"
    [fields]="filterFields"
    [showClearButton]="true"
    (onClear)="clearFilters()">
  </app-generic-filter>

  <!-- Dashboard Cards -->
  <div *ngIf="!loading" class="row g-4">
    <div *ngFor="let statusCount of statusCounts" class="col-12 col-sm-6 col-xl-4">
      <app-status-card
        [title]="statusCount.status === PackagingStatusHelper.Received
          ? ((statusCount.translateKey | translateAsync) + ' (' + ('$index.txtLast30Days' | translateAsync) + ')')
          : statusCount.translateKey"
        [count]="statusCount.count"
        [statusColor]="statusCount.color"
        [countLabel]="'$index.txtPackagings'"
        [footerText]="'$index.txtClickToSeeList'"
        [icon]="'fa-box'"
        [clickable]="hasRolePackagingsList"
        (onClick)="navigateToPackagingList(statusCount.status)">
      </app-status-card>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && statusCounts.length === 0" class="text-center py-5">
    <i class="fa-solid fa-box-open fa-3x text-muted mb-3"></i>
    <p class="text-muted" translate>$index.txtNoData</p>
  </div>
</div>
